import { DatePipe } from "@angular/common";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import * as appConfigActions from "../../../reducers/appconfig.actions";
import {
    CommonService,
    SampleService
} from "../../../services/index";

@Component({
  selector: "addedit-invoice-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./sampleFair.html",
})
export class sampleFair implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() _params: any;
  @Output() tabUpdateEvent = new EventEmitter();

  mode = "Add";
  saveEvent: any;
  ironingList: any;
  presentationList: any;
  beltNoList: any;
  designList: any;
  matchColorList: any;
  samp_id: any;

  styleNoList: any;

  @Input() set params(val: any[]) {}

  get params(): any[] {
    return this._params;
  }

  page_id: string = Math.random().toString(36).substr(2, 9) + "_";
  groupdata: any = { sample_no: "", tot_pcs: 0, tot_amt: 0 };
  isLoading: boolean = false;
  companyList$ = [];
  sampleno: any;
  collarList: any;
  partyList: any = [];
  finyearList = [];
  list: any;
  designnoList = [];

  companyList: Observable<any[]>;
  partycodeList = [];
  usagepartslist = [];
  shadeList = [];
  shades = [];
  colorList: any = [];
  shirtList: any = [];
  itemgroupList = [];
  sampleList = [];
  itemList = [];
  matchingList: any;
  accessoriesList = [
    "BUTTON",
    "THREAD",
    "COLLAR CANVAS",
    "KAJA THREAD",
    "BUTTON THREAD",
    "PLK",
    "CLR-UP",
    "CLR-DN",
    "BND DOWN",
    "BAND UP",
    "CUFF CANVAS",
    "MAIN LABEL",
    "EXTRA LABEL",
    "WASH CARE",
    "BONE",
    "BUT PATTI",
  ];
  sample: any = {};
  // itemList1: Observable<any[]>;

  @ViewChild("partycodeAuto") partycodeAuto;
  @ViewChild("partyAuto") partyAuto;
  @ViewChild("finAuto") gstAuto;

  invnoControl: FormControl = new FormControl();
  ponoControl: FormControl = new FormControl();
  itemCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();
  partycomboControl: FormControl = new FormControl();
  brandControl: FormControl = new FormControl();

  sample_data: any;
  groupData: any = [];
  data: any = {};
  sampledata: any;
  groupList: any = [
    {
      sample_id: "",
      sample_no: "",
      shirt_design_no: "",
      color: "",
      shade: "",
      size: "",
      slv: "",
      pcs: "",
      rate: "",
      mrp: "",
      amount: "",
    },
  ];
  isLoadMask: Promise<any>;
  categoryList: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public toasterService: ToasterService,
    private commonService: CommonService,
    private sampService: SampleService,
    public datePipe: DatePipe
  ) {
    function hasValidItem(input: FormControl) {
      let id = input.value,
        retVal = null;
      if (id == "") {
        retVal = { inValid: true };
      }
      if (id && typeof id === "string") {
        retVal = { inValid: true };
      }
      return retVal;
    }

    this.partyCtrl = new FormControl("", [
      Validators.required,
      hasValidItem.bind(this),
    ]);
    this.data = this.commonService.itemMaster();
    console.log(this.data);
  }
  hotkeys(event) {
    if (this.active) {
    }
  }

  trackByIndex(index: number, value: any) {
    return index;
  }

  ngOnInit(): void {}

  /*  tableScroll(){
       
        $('.samplemain').width(window.innerWidth -525);
        $('.samplebody').width(window.innerWidth -485);f
        if(window.innerWidth>1500){
            $('.techstyleinput').width(window.innerWidth-1045);
        }else{
            $('.techstyleinput').width(window.innerWidth-865);
        }

    } */
  onClickSample(sample_no) {
    let params = {
      sample_no: sample_no,
    };
    this.sampService.getSamplefairList(params).then((res: any) => {
      this.sampleList = res.data;
      let colors = res.data[0].sample_color;
      this.colorList = colors.split(",");
      this.categoryList = res.category;
      this.samp_id = res.data[0].samp_id;
    });
  }
  getcontents(ind) {
    this.groupList[ind].size = this.sampleList[0].size;
    this.groupList[ind].slv = this.sampleList[0].slv;
    this.groupList[ind].shirt_design_no = this.sampleList[0].shirt_design_no;
    let category = this.categoryList;
    if (this.sampleList[0].slv == "F/S") {
      this.groupList[ind].mrp = category.mrp;
      this.groupList[ind].rate = category.fs_rate;
    } else {
      this.groupList[ind].mrp = category.mrp;
      this.groupList[ind].rate = category.hs_rate;
    }
  }
  calamt(pcs, ind) {
    let temp = this.categoryList;
    this.groupList[ind].amount = this.groupList[ind].rate * pcs;
    this.groupdata.tot_pcs = 0;
    this.groupdata.tot_amt = 0;
    for (var i = 0; i < this.groupList.length; i++) {
      this.groupdata.tot_pcs += parseInt(this.groupList[i].pcs);
      this.groupdata.tot_amt += parseInt(this.groupList[i].amount);
    }
  }
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      sample_no = this.groupList[ind]["sample_no"],
      shirt_design_no = this.groupList[ind]["shirt_design_no"],
      color = this.groupList[ind]["color"],
      shade = this.groupList[ind]["shade"],
      size = this.groupList[ind]["size"],
      slv = this.groupList[ind]["slv"],
      //  width = this.data.designList[ind]['width'],
      pcs = this.groupList[ind]["pcs"],
      mrp = this.groupList[ind]["mrp"],
      rate = this.groupList[ind]["rate"],
      amount = this.groupList[ind]["amount"];

    let nxtRow = $("#row-" + ind).next("tr");

    //         for (let i = 0; i < this.groupList.length; i++) {
    //             if (ind + 1 == this.groupList.length) {

    //              //   let rowdetail = Object.assign({}, this.row);

    //                 this.groupData.push();

    //                 nxtInd = this.groupList.length - 1;

    //     }
    // }
    if (fld == "sample_no" && nxtRow.length == 0) {
      let len = this.groupList.length;
      let sample_no = this.groupList[len - 1]["sample_no"];
      //  let qty = this.groupList[len-1].qty;
      nxtInd = nxtInd + 1;
      $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();

      if (sample_no != "" && nxtInd == len) {
        this.groupList.push({
          sample_no: "",
          shirt_design_no: "",
          color: "",
          shade: "",
          size: "",
          slv: "",
          pcs: "",
          rate: "",
          mrp: "",
          amount: "",
        });
        this.groupList[ind].samp_id = this.groupList[0].samp_id;
        $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();
      } else if (sample_no == "" && nxtInd == len) {
        let a = nxtInd - 1;
        $("#" + this.page_id + "sample_no" + "-" + a).focus();
      } else {
        $("#" + this.page_id + "sample_no" + "-" + nxtInd).focus();

        return false;
      }
    }
    setTimeout(() => {
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }
  loadeditsamplelist(sample_id) {
    let params = {
      samp_id: sample_id,
    };
    this.sampService.getEditSampleList(params).then((res: any) => {
      this.sampleList = res.data;
      this.getshades(this.sampleList);
    });
  }
  getshades(sample_data) {
    // let coloList = row.sample_color;
    let sample_no = sample_data[0].sample_no;
    let params = {
      sample_no: sample_no,
    };

    this.sampService.getShadeList(params).then((res: any) => {
      let data1: any = res.data;

      for (var i = 0; i < data1.length; i++) {
        for (var key in data1[i]) {
          let temp = data1[i][key];
          this.shades.push(temp);
        }
      }
      //    this.clickPrint(sample_data,this.shades);
      console.log(res);
    });
  }
  clickPrint(sample_data, data) {
    let that = this;
    let params: any = Object.assign({}, sample_data[0]);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.sampService
      .fairStickerprint(params)
      .then(function (res: any) {});
  }

  getshadeList(sample_no, color, ind) {
    let params = {
      color: color,
      sample_no: sample_no,
    };
    this.sampService.getfairShadeList(params).then((res: any) => {
      this.groupList[ind].shade = res.data.shade;
    });
  }
  // getStyleNoList(){
  //     this.sampService
  //     .getStyleNoList({})
  //     .then((res: any) => {

  //       this.styleNoList = res.data;

  //     });
  // }

  // generateDNo(style){
  //
  //                 let params={
  //                     style: style
  //                 }
  //     this.sampService
  //                     .getDesignNo(params)
  //                     .then((res: any) => {

  //                         this.sampledata.shirt_design_no = res.data[0].shirtdno;

  //                     });

  //             }

  getDesignList() {
    this.sampService.getDesignList({}).then((res: any) => {
      this.designList = res.data;
    });
  }

  onSelectDesign(match_design, sampdata) {
    let params = {
      design_no: match_design,
    };
    this.sampService.getMatchColor(params).then((res: any) => {
      this.matchColorList = res.data;
    });

    /*   sampdata.kaja_thread = this.sampledata.kthread_cons;
                      sampdata.button_thread = this.sampledata.bthread_cons; */
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#" + "date").focus();
    }, 100);
  }

  onEnterKeyPressed() {
    $("#" + "sample_no-0").focus();
  }

  // onGoToNextFld($event, fld, ind) {
  //     let nxtInd = ind,
  //     fab_color = this.groupList[ind]['main_fab_color'];

  // let nxtRow = $('#row-' + ind).next('tr');

  // if (fab_color != '') {
  //     if (fld == "fab_color" && nxtRow.length == 0) {
  //         for (let i = 0; i < this.groupList.length; i++) {
  //             if (ind + 1 == this.groupList.length) {
  //                 this.groupList.push({
  //                     main_fab_color: '',
  //                     mat1_des_no: '',
  //                     mat1_color: '',
  //                     mat2_des_no:'',
  //                     mat2_color: '',
  //                     mat3_des_no: '',
  //                     mat3_color: '',
  //                     tape_no:'',
  //                     kaja_thread:'',
  //                     button_no:'',
  //                     button_thread:''
  //                 });

  //                 nxtInd = this.groupList.length - 1;
  //             }
  //         }
  //     }
  // }
  // setTimeout(() => {
  //     let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
  //     a.removeClass('mat-autocomplete-visible');
  //     $('#' + fld + '-' + nxtInd).focus();
  // }, 100);
  // }

  onGoToUpAndDown($event, fld, arrow, ind) {
    //
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
      $("#" + this.page_id + fld + "-" + ind).focus();
    }
  }

  onkeyrightleft($event, arrow, fld) {
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }

    if ($("#" + this.page_id + fld).length > 0) {
      $("#" + this.page_id + fld).focus();
    }
  }

  filterItems(name: string, comboType: string) {
    let list: any[];
    if (comboType == "Company") {
      list = this.companyList$;
    } else if (comboType == "Party") {
    }
    name = _.escapeRegExp(name);
    return list.filter((item) => new RegExp(name, "gi").test(item.name));
  }

  onEnterdesignno(list, ind) {
    let params = {
      design_no: list.design_no,
    };

    this.sampService.designlist(params).then((res: any) => {
      this.shadeList = res;

      // this.calcConsumption('$event',ind);
    });
  }

  // oncheckemptyrow() {
  //
  //     let list = this.groupList;
  //     let sampleList = [];
  //     for (let i = 0; i < list.length; i++) {
  //         if (list[i].main_fab_color != '') {
  //             sampleList.push(list[i]);
  //         }
  //     }
  //     this.groupList = sampleList;
  //     this.onSaveSample();
  // }

  addfairSample() {
    let design = this.groupList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      design[i].samp_id = this.samp_id;
      if (design[i].sample_no != "") {
        desList.push(design[i]);
      }
    }
    this.groupList = desList;
    this.loadsample(this.groupList[0].samp_id);
    this.savefairSample();
  }
  loadsample(sample_id) {
    let params = {
      samp_id: sample_id,
    };
    this.sampService.loadsampledata(params).then((res: any) => {
      this.sample_data = res;
    });
  }
  fairSticker(sample_id) {
    let params = {
      samp_id: sample_id,
    };
    this.sampService.fairSticker(params).then((res: any) => {
      let stickerData = res.data;
      //     this.clickPrint(stickerData);
    });
  }
  // clickPrint(data){

  //     let that = this;

  //     let params: any = Object.assign({});
  //     params['data'] = JSON.stringify(data);
  //     that.sampService
  //         .fairStickerprint(params)
  //         .then(function (res: any) {

  //         });
  // }
  resetform() {
    $("#f1").trigger("reset");
    this.groupdata.tot_pcs = 0;
    this.groupdata.tot_amt = 0;
    this.groupdata.sample_no = "";
    this.groupList = [
      {
        sample_id: "",
        sample_no: "",
        shirt_design_no: "",
        color: "",
        shade: "",
        size: "",
        slv: "",
        pcs: "",
        rate: "",
        mrp: "",
        amount: "",
      },
    ];
    this.sampleList = [];
    this.colorList = [];
  }
  savefairSample() {
    if (
      this.groupList[0].sample_no == "" ||
      this.groupList[0].amount == "" ||
      this.groupList[0].color == "" ||
      this.groupList[0].pcs == ""
    ) {
      swal("make sure all the datas are given");
    } else {
      let params: any = Object.assign({}, this.sampledata);
      params["tabevent"] = undefined;
      params["fairList"] = JSON.stringify(this.groupList);
      //  params['workorder'] = this.dcdata.workorder || '';
      params["mode"] = this.mode;

      let that = this;
      that.isLoading = true;
      //  params['groupList'] = JSON.stringify(this.groupList);

      swal({
        title: "Are you sure to save this Sample?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(
        function () {
          that.isLoading = true;
          that.sampService
            .addfairSample(params)
            .then(function (res: any) {
              that.isLoading = false;
              if (that.saveEvent) {
                that.saveEvent.emit();
              }

              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                that.store.dispatch(new appConfigActions.SetLoadInvoice(true));
                that.loadsample(that.groupList[0].samp_id);
                that.loadeditsamplelist(that.groupList[0].samp_id);
                that.isLoadMask = that.sampService
                  .fairStickerprint(res)
                  .then(function (res: any) {});
                that.resetform();
              } else {
                swal("ERROR", res.message, "error");
              }
            })
            .catch(function (error: any) {
              that.isLoading = false;
              let res = JSON.parse(error._body);
              swal("ERROR", res.message, "error");
            });
        },
        function (dismiss) {}
      );
    }
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/sampleFair.ts